<template>
  <b-modal v-model="isShow" @hide="onClose">
    <template #modal-title>
      {{ $t('Project URL Edit') }}
    </template>
    <b-container fluid>
      <template>
        <b-row class="mt-2 mb-4">
          <b-col> {{ $t('Image URL') }} </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col>
            <b-form-input
              v-model="imageUrl"
              type="text"
              :placeholder="$t('Image URL')"
              class="form-control-alternative"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col> {{ $t('Circuit Diagram URL') }} </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col>
            <b-form-input
              v-model="circuitUrl"
              type="text"
              :placeholder="$t('Circuit Diagram URL')"
              class="form-control-alternative"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col> {{ $t('Youtube URL') }} </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col>
            <b-form-input
              v-model="youtubeUrl"
              type="text"
              :placeholder="$t('Youtube URL')"
              class="form-control-alternative"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-4">
          <b-col>
            {{ $t('Youtube URL Start with') }} : https://www.youtube.com/embed/
          </b-col>
        </b-row>
      </template>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100">
        <div class="float-right">
          <b-button
            variant="primary"
            size="sm"
            @click="save"
            :disabled="!urlEditButtonEnable"
          >
            {{ $t('Save') }}
          </b-button>
          <b-button size="sm" @click="ok">
            {{ $t('Cancle') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RenameProjectPopup',
  data() {
    return {
      isShow: false,
      urlEditHandler: undefined,
      imageUrl: '',
      youtubeUrl: '',
      circuitUrl: '',
      isSample: false,
      originProjectName: '',
      originProject: {},
      urlEditButtonEnable: false
    }
  },
  computed: {
    ...mapState(['urlEditProjectPopupData'])
  },
  methods: {
    save() {
      if (this.urlEditHandler) {
        const project = _.cloneDeep(this.originProject)
        project.image = _.trim(this.imageUrl)
        project.youtube = _.trim(this.youtubeUrl)
        project.circuit = _.trim(this.circuitUrl)
        this.urlEditHandler(this, project)
      }
    },
    onClose() {
      this.originProject = {}
      this.urlEditHandler = undefined
      this.urlEditButtonEnable = false
    },
    checkChange() {
      const imageUrl = _.trim(this.imageUrl)
      const youtubeUrl = _.trim(this.youtubeUrl)
      const circuitUrl = _.trim(this.circuitUrl)
      const originImage = _.get(this.originProject, 'image', '')
      const originYoutube = _.get(this.originProject, 'youtube', '')
      const originCircuit = _.get(this.originProject, 'circuit', '')
      this.urlEditButtonEnable =
        imageUrl !== originImage ||
        youtubeUrl !== originYoutube ||
        circuitUrl !== originCircuit
    }
  },
  watch: {
    urlEditProjectPopupData() {
      if (this.urlEditProjectPopupData.isShow) {
        const { originProject, urlEditHandler } = this.urlEditProjectPopupData
        this.isShow = true
        this.originProject = originProject
        this.imageUrl = originProject.image
        this.youtubeUrl = originProject.youtube
        this.circuitUrl = originProject.circuit
        this.urlEditHandler = urlEditHandler
      } else {
        this.isShow = false
        this.originProject = {}
        this.urlEditHandler = undefined
        this.urlEditButtonEnable = false
      }
    },
    imageUrl() {
      this.checkChange()
    },
    youtubeUrl() {
      this.checkChange()
    },
    circuitUrl() {
      this.checkChange()
    }
  }
}
</script>

<style scoped>
button.btn-danger {
  margin-right: 10px;
}
</style>
